import ModelUtil from '@leverege/model-util';
import { v4 } from '@leverege/base62-util';
import Key from "./Key.js";
/**
 * This represents a DataViewer reference. It contains the type, and settings for
 * the data viewer, and an id. This is not strictly a model, but more a utility
 * class that can be used to produce data viewer entries in the LayoutModel, CardModels,
 * and others that combine data viewers
 * @param {string} type The type of dataviewer
 * @param {object} settings The model used by the data viewer to store its options
 * @returns 
 */
function create(type, settings) {
  return {
    id: v4(),
    type,
    settings
  };
}
export default {
  create,
  ...ModelUtil.createAllValue('type'),
  ...ModelUtil.createAllValue('settings'),
  getId: model => {
    return model.id;
  },
  getSettingsPath(model, settingsRoot) {
    const {
      type,
      id
    } = model;
    const key = type && id ? `${type}.${id}` : id || type;
    return settingsRoot ? Key.forSettings(settingsRoot, key) : key;
  },
  /**
   * Copies and changes the id of the model
   * @param {Model} model The {id,type,settings} object
   * @returns a DataViewer with new id.
   */
  copy: model => {
    return {
      ...model,
      id: v4()
    };
  }
};